import React from 'react';

export default function SectionHeader({ icon, title, subtitle }) {
  return (
    <header className="section-header">
      {icon && <span className="section-header__icon" aria-hidden="true">{icon}</span>}
      <div>
        <h2 className="section-header__title">{title}</h2>
        {subtitle && <p className="section-header__subtitle">{subtitle}</p>}
      </div>
    </header>
  );
}
